<template>
  <section v-if="isLoaded">
    <HeaderBackground :backgroundPath="`/${$staticPath}/${index.backgroundPath}`"
      :backgroundOverlayPath="`/${$staticPath}/${index.backgroundOverlayPath}`"
    ></HeaderBackground>
    <div class="content">
      <Header :headerText="index.headerText"></Header>
      <Vision :headerBar="vision.headerBar" :imageInfo="vision.imageInfo"></Vision>
      <Room :headerBar="room.headerBar" :imageList="room.room"></Room>
      <Facilities :headerBar="facilities.headerBar" :moreInfo="facilities.moreInfo" :imageSet="facilities.imageSet"></Facilities>
      <Info :headerBar="info.headerBar" :regulation="info.regulation" :faq="info.faq" :dataSet="info.dataSet"></Info>
      <Contact :headerBar="contact.headerBar" :address="contact.address" :tel="contact.tel" :route="contact.route" :map="contact.map"></Contact>
    </div>
  </section>
</template>

<script>
import HeaderBackground from '../COMMON/HeaderBackground'
import Header from '../COMMON/Header'
import Vision from './Vision.vue'
import Room from './Room.vue'
import Facilities from './Facilities.vue'
import Info from './Info.vue'
import Contact from './Contact.vue'

export default {
  components: {
    HeaderBackground,
    Header,
    Vision,
    Room,
    Facilities,
    Info,
    Contact
  },
  data () {
    return {
      isLoaded: false,
      index: {},
      vision: {},
      room: {},
      facilities: {},
      info: {},
      contact: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var index = await import('../../json/en/dormitory/index.json')
        var vision = await import('../../json/en/dormitory/vision.json')
        var room = await import('../../json/en/dormitory/room.json')
        var facilities = await import('../../json/en/dormitory/facilities.json')
        var info = await import('../../json/en/dormitory/info.json')
        var contact = await import('../../json/en/dormitory/contact.json')
      } else {
        index = await import('../../json/th/dormitory/index.json')
        vision = await import('../../json/th/dormitory/vision.json')
        room = await import('../../json/th/dormitory/room.json')
        facilities = await import('../../json/th/dormitory/facilities.json')
        info = await import('../../json/th/dormitory/info.json')
        contact = await import('../../json/th/dormitory/contact.json')
      }
      this.index = index
      this.vision = vision
      this.room = room
      this.facilities = facilities
      this.info = info
      this.contact = contact
      this.isLoaded = true
    }
  }
}
</script>

<style scoped>
  .content {
    background-color: #FFF;
    padding: 60px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/DORM/Index.vue